export const CHROME_EXT_ID = "bkokmlhcdmoeobdcabifliikflimplol";
export const PUBLIC_CAMPAIGN_ID = 57;
